// ============================================================
//  ALTIMO Medical Center — App.jsx  (v2 — Fase 1 Farmacia)
//  Ubicación: src/App.jsx
//  Cambios v2:
//    ✓ Import Inventario añadido
//    ✓ Ícono inventario en Ico
//    ✓ Módulo 'inventario' en MODULOS (sección SERVICIOS)
//    ✓ Permisos inventario: admin, farmacia
//    ✓ Permisos ajustados por rol según áreas reales
//    ✓ Case 'inventario' en renderContenido
//    ✓ Control para evitar vista inválida si el rol no tiene acceso
// ============================================================

import { useState, useEffect, useMemo, useRef } from 'react';
import Dashboard             from './components/Dashboard';
import AdmisionModulo        from './components/AdmisionModulo';
import CuentaPaciente        from './components/CuentaPaciente';
import Habitaciones          from './components/Habitaciones';
import Turnos                from './components/Turnos';
import FacturacionModulo     from './components/FacturacionModulo';
import Reportes              from './components/Reportes';
import Tarifario             from './components/Tarifario';
import ExpedientePaciente    from './components/ExpedientePaciente';
import Laboratorio           from './components/Laboratorio';
import ClinicaMedica         from './components/ClinicaMedica';
import Enfermeria            from './components/Enfermeria';
import Medicos               from './components/Medicos';
import Usuarios              from './components/Usuarios';
import Inventario            from './components/Inventario';
import ActivosFijos          from './components/ActivosFijos';
import ProgramacionQuirofano from './components/ProgramacionQuirofano';
import Farmacia              from './components/Farmacia';
import BuscadorGlobal        from './components/BuscadorGlobal';
import logo                  from './assets/Logoaltimo.png';
import logoBlanco            from './assets/LogoaltimoBlanco.png';
import api                   from './apiClient'; // ← NUEVO: reemplaza window.altimo (IPC) por HTTP al servidor

// ── Estilos globales del shell ────────────────────────────────
const G = {
  app:           { display:'flex', height:'100vh', overflow:'hidden', fontFamily:'Segoe UI, sans-serif', background:'#f0f4f8' },
  sidebar:       { width:'210px', background:'#1B2A5E', display:'flex', flexDirection:'column', flexShrink:0 },
  logoArea:      { background:'#fff', padding:'14px 12px 10px', borderBottom:'1px solid #e0e0e0' },
  logoImg:       { width:'100%', maxWidth:'160px', display:'block' },
  navSection:    { padding:'14px 14px 4px', fontSize:'10px', color:'#7fa3cc', letterSpacing:'.1em', textTransform:'uppercase' },
  navSectionBtn: (abierta) => ({ padding:'12px 14px 6px', marginTop:'4px', fontSize:'10px', color:'#7fa3cc', letterSpacing:'.1em', textTransform:'uppercase', display:'flex', alignItems:'center', justifyContent:'space-between', cursor:'pointer', userSelect:'none', fontWeight:'700', borderTop:'1px solid rgba(255,255,255,.06)' }),
  navSectionArrow: (abierta) => ({ fontSize:'10px', transform: abierta ? 'rotate(90deg)' : 'rotate(0deg)', transition:'transform .15s', color:'#b8cfe8' }),
  navItem: (activo) => ({
    display:'flex', alignItems:'center', gap:'9px',
    padding:'11px 16px', margin:0, borderRadius:0,
    cursor:'pointer', fontSize:'13px',
    borderBottom:'1px solid rgba(255,255,255,.14)',
    color:      activo ? '#1B2A5E' : '#dbe7f5',
    background: activo ? '#ffffff' : 'transparent',
    fontWeight: activo ? '700'     : '400',
    transition:'background .12s, color .12s',
  }),
  main:          { flex:1, display:'flex', flexDirection:'column', overflow:'hidden', minWidth:0 },
  topbar:        { height:'50px', background:'#fff', borderBottom:'1px solid #dde3ea', display:'flex', alignItems:'center', padding:'0 20px', gap:'12px', flexShrink:0 },
  topbarTitulo:  { fontSize:'15px', fontWeight:'700', color:'#1B2A5E', flex:1 },
  badge: (color) => ({ fontSize:'11px', padding:'3px 10px', borderRadius:'99px', background: color || '#e8f0fb', color:'#1B2A5E', fontWeight:'600' }),
  usuarioNombre: { fontSize:'12px', color:'#6c757d' },
  contenido:     { flex:1, overflowY:'auto' },
};

// ── Íconos SVG ───────────────────────────────────────────────
const Ico = {
  dashboard:    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="1" y="1" width="6" height="6" rx="1.5"/><rect x="9" y="1" width="6" height="6" rx="1.5"/><rect x="1" y="9" width="6" height="6" rx="1.5"/><rect x="9" y="9" width="6" height="6" rx="1.5"/></svg>,
  admision:     <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="5" r="3"/><path d="M2 14c0-3 2.7-5 6-5s6 2 6 5"/></svg>,
  cuenta:       <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 2h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"/><path d="M5 5h6M5 8h6M5 11h4"/></svg>,
  habitaciones: <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="1" y="6" width="14" height="9" rx="1"/><path d="M4 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M1 10h14"/></svg>,
  facturacion:  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="1" width="12" height="14" rx="1.5"/><path d="M5 5h6M5 8h6M5 11h3"/></svg>,
  reportes:     <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 12 L5 8 L8 10 L11 5 L14 7"/><rect x="2" y="13" width="12" height="1" rx=".5"/></svg>,
  activosFijos: <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="12" height="10" rx="1.5"/><path d="M2 7h12M6 3v10"/></svg>,
  tarifario:    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="8" r="6"/><path d="M8 5v6M6 6.5h3a1.5 1.5 0 0 1 0 3H6"/></svg>,
  expediente:   <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 2h8a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"/><path d="M5 5h6M5 8h6M5 11h3"/><circle cx="11" cy="11.5" r="2" fill="currentColor" stroke="none" opacity=".4"/></svg>,
  formulario:   <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="2" width="12" height="12" rx="2"/><path d="M5 6h6M5 9h4"/><path d="M10 12l2-2-2-2"/></svg>,
  laboratorio:  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M6 2v5L3 13h10L10 7V2"/><line x1="5" y1="5" x2="11" y2="5"/></svg>,
  medicos:      <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="5" r="2.5"/><path d="M3 14c0-2.8 2.2-5 5-5s5 2.2 5 5"/><path d="M11 9v3M9.5 10.5h3"/></svg>,
  usuarios:     <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="5" cy="5" r="2.5"/><path d="M1 14c0-2.8 1.8-4 4-4s4 1.2 4 4"/><circle cx="12" cy="5" r="2"/><path d="M10 14c0-1.6 1-3 2-3s2 1.4 2 3"/></svg>,
  logout:       <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M6 14H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3"/><path d="M10 11l3-3-3-3M13 8H6"/></svg>,
  inventario:   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/></svg>,
  farmaciaDespacho: <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="2" width="12" height="12" rx="3"/><path d="M5.5 8h5M8 5.5v5"/></svg>,
  quirofano:    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="1" y="3" width="14" height="10" rx="2"/><path d="M5 8h6M8 5v6"/></svg>,
  turnos:       <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="8" r="6.5"/><path d="M8 4.5V8l2.5 2"/></svg>,
  clinica:      <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="5" r="2.5"/><path d="M3 14c0-2.8 2.2-5 5-5s5 2.2 5 5"/><path d="M6 8v4M4 10h4"/></svg>,
  enfermeria:   <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="12" height="10" rx="2"/><path d="M8 6v4M6 8h4"/></svg>,
};

// ══════════════════════════════════════════════════════════════
//  MÓDULOS
// ══════════════════════════════════════════════════════════════
const MODULOS = [
  { id:'dashboard',    label:'Dashboard',             seccion:'PRINCIPAL',    ico: Ico.dashboard    },
  { id:'admision',     label:'Admisión',              seccion:'ADMISIÓN',     ico: Ico.admision     },
  { id:'expediente',   label:'Expedientes',           seccion:null,           ico: Ico.expediente   },
  { id:'clinica',      label:'Clínico / Médico',      seccion:'CLÍNICO',      ico: Ico.clinica      },
  { id:'enfermeria',   label:'Enfermería',            seccion:null,           ico: Ico.enfermeria   },
  { id:'quirofano',    label:'Quirófanos',            seccion:'SERVICIOS',    ico: Ico.quirofano    },
  { id:'turnos',       label:'Turnos',                seccion:null,           ico: Ico.turnos       },
  { id:'laboratorio',  label:'Laboratorio',           seccion:null,           ico: Ico.laboratorio  },
  { id:'habitaciones', label:'Habitaciones',          seccion:null,           ico: Ico.habitaciones },
  { id:'inventario',   label:'Stock de Medicamentos', seccion:null,           ico: Ico.inventario   },
  { id:'farmacia',     label:'Despacho de Farmacia',  seccion:null,           ico: Ico.farmaciaDespacho },
  { id:'medicos',      label:'Médicos',               seccion:null,           ico: Ico.medicos      },
  { id:'cuenta',       label:'Cuenta paciente',       seccion:'FACTURACIÓN',  ico: Ico.cuenta       },
  { id:'facturacion',  label:'Facturación',           seccion:null,           ico: Ico.facturacion  },
  { id:'activosFijos', label:'Activo Fijo',           seccion:null,           ico: Ico.activosFijos },
  { id:'reportes',     label:'Reportes',              seccion:null,           ico: Ico.reportes     },
  { id:'tarifario',    label:'Tarifario',             seccion:'SISTEMA',      ico: Ico.tarifario    },
  { id:'usuarios',     label:'Usuarios',              seccion:null,           ico: Ico.usuarios     },
];

// ══════════════════════════════════════════════════════════════
//  PERMISOS POR ROL
// ══════════════════════════════════════════════════════════════
const PERMISOS = {
  dashboard:    ['admin','caja','laboratorio','farmacia','medico','jefe_medico','enfermeria','jefa_enfermeria','supervisora_turno'],
  admision:     ['admin','admision','recepcion'],
  expediente:   ['admin','medico','jefe_medico','enfermeria','jefa_enfermeria','supervisora_turno'],
  clinica:      ['admin','medico','jefe_medico','enfermeria','jefa_enfermeria','supervisora_turno'],
  enfermeria:   ['admin','enfermeria','jefa_enfermeria','supervisora_turno'],
  habitaciones: ['admin','jefa_enfermeria'],
  quirofano:    ['admin','medico','jefe_medico','enfermeria','jefa_enfermeria','supervisora_turno','admision','recepcion'],
  turnos:       ['admin','medico','jefe_medico','enfermeria','jefa_enfermeria','supervisora_turno'],
  laboratorio:  ['admin','laboratorio'],
  inventario:   ['admin','farmacia'],
  farmacia:     ['admin','farmacia'],
  medicos:      ['admin','admision'],
  cuenta:       ['admin','caja'],
  facturacion:  ['admin','caja'],
  reportes:     ['admin','caja','contaduria','auditoria'],
  tarifario:    ['admin'],
  activosFijos: ['admin','contaduria'],
  usuarios:     ['admin'],
};

// ── Color y nombre legible por rol ───────────────────────────
const ROL_COLOR = {
  admin:              '#d4edda',
  caja:               '#cce5ff',
  admision:           '#fff3cd',
  medico:             '#e2d9f3',
  jefe_medico:        '#c8d8f8',
  enfermeria:         '#d1ecf1',
  jefa_enfermeria:    '#a8dbe5',
  supervisora_turno:  '#e0d0f0',
  laboratorio:        '#f4c0d1',
  farmacia:           '#d4edda',
  recepcion:          '#e8f0fb',
  contaduria:         '#ffe8b3',
  auditoria:          '#e2e2e2',
};

const ROL_LABEL = {
  admin:              'Administrador',
  caja:               'Caja / Facturación',
  admision:           'Admisión',
  medico:             'Médico',
  jefe_medico:        'Jefe Médico de Turno',
  enfermeria:         'Enfermería',
  jefa_enfermeria:    'Jefa de Enfermería',
  supervisora_turno:  'Supervisora de Turno',
  laboratorio:        'Laboratorio',
  farmacia:           'Farmacia / Botiquín',
  recepcion:          'Recepción',
  contaduria:         'Contaduría',
  auditoria:          'Auditoría',
};

// ════════════════════════════════════════════════════════════
//  LOGIN
// ════════════════════════════════════════════════════════════
const LOGIN_CSS = `
  @keyframes altimoSpin      { to { transform: rotate(360deg); } }
  @keyframes altimoFadeUp    { from { opacity:0; transform:translateY(18px); } to { opacity:1; transform:translateY(0); } }
  @keyframes altimoPulseRing { 0% { transform:scale(1); opacity:.6; } 100% { transform:scale(2.2); opacity:0; } }
  @keyframes altimoHeartbeat {
    0%,100% { transform:scale(1); } 14% { transform:scale(1.09); }
    28% { transform:scale(1); } 42% { transform:scale(1.06); } 56% { transform:scale(1); }
  }
  @keyframes altimoGlow {
    0%,100% { box-shadow: 0 0 18px rgba(29,158,117,0.25); }
    50%     { box-shadow: 0 0 38px rgba(29,158,117,0.55); }
  }
  @keyframes altimoECG { 0% { stroke-dashoffset: 1000; } 100% { stroke-dashoffset: 0; } }
`;

function Login({ onLogin }) {
  const [creds,    setCreds]    = useState({ usuario:'', password:'' });
  const [cargando, setCargando] = useState(false);
  const [error,    setError]    = useState('');
  const [showPass, setShowPass] = useState(false);
  const [phase,    setPhase]    = useState(0);
  const canvasRef = useRef(null);
  const animRef   = useRef(null);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 80);
    const t2 = setTimeout(() => setPhase(2), 300);
    const t3 = setTimeout(() => setPhase(3), 520);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let W = canvas.width  = canvas.offsetWidth;
    let H = canvas.height = canvas.offsetHeight;
    const N = 55;
    const pts = Array.from({ length: N }, () => ({
      x: Math.random() * W, y: Math.random() * H,
      vx: (Math.random() - .5) * .45, vy: (Math.random() - .5) * .45,
      r:  Math.random() * 1.8 + .6,
    }));
    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      for (let i = 0; i < N; i++) {
        for (let j = i + 1; j < N; j++) {
          const dx = pts[i].x - pts[j].x;
          const dy = pts[i].y - pts[j].y;
          const d  = Math.sqrt(dx*dx + dy*dy);
          if (d < 110) {
            ctx.beginPath();
            ctx.moveTo(pts[i].x, pts[i].y);
            ctx.lineTo(pts[j].x, pts[j].y);
            ctx.strokeStyle = 'rgba(29,158,117,' + (.18 * (1 - d/110)) + ')';
            ctx.lineWidth = .7;
            ctx.stroke();
          }
        }
      }
      pts.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(29,158,117,0.55)';
        ctx.fill();
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0 || p.x > W) p.vx *= -1;
        if (p.y < 0 || p.y > H) p.vy *= -1;
      });
      animRef.current = requestAnimationFrame(draw);
    };
    const onResize = () => {
      W = canvas.width  = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    };
    window.addEventListener('resize', onResize);
    animRef.current = requestAnimationFrame(draw);
    return () => {
      cancelAnimationFrame(animRef.current);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const handleLogin = async () => {
    if (!creds.usuario || !creds.password) { setError('Completa usuario y contraseña.'); return; }
    setCargando(true); setError('');
    const r = await api.usuarios.login(creds); // ← antes: window.altimo.usuarios.login(creds)
    setCargando(false);
    if (r.ok) onLogin(r.data);
    else setError(r.error || 'Credenciales incorrectas');
  };

  const fd = (d) => ({
    opacity:   phase >= 3 ? 1 : 0,
    transform: phase >= 3 ? 'translateY(0)' : 'translateY(12px)',
    transition: 'opacity .55s ease ' + d + 's, transform .55s ease ' + d + 's',
  });

  return (
    <div style={{ display:'flex', height:'100vh', overflow:'hidden', fontFamily:'Segoe UI, sans-serif' }}>
      <style>{LOGIN_CSS}</style>

      {/* ── Panel izquierdo ── */}
      <div style={{
        flex:1, position:'relative', overflow:'hidden',
        background:'linear-gradient(155deg,#060f26 0%,#0d1e45 40%,#1B2A5E 70%,#0a3360 100%)',
        opacity:   phase >= 1 ? 1 : 0,
        transform: phase >= 1 ? 'translateX(0)' : 'translateX(-48px)',
        transition:'opacity .65s ease, transform .65s ease',
      }}>
        <canvas ref={canvasRef} style={{ position:'absolute', inset:0, width:'100%', height:'100%' }} />
        <div style={{ position:'absolute', inset:0, background:'radial-gradient(ellipse 60% 60% at 50% 48%,rgba(29,158,117,0.10) 0%,transparent 70%)', pointerEvents:'none' }} />

        {/* ECG animado */}
        <div style={{ position:'absolute', bottom:'22%', left:0, right:0, height:'52px', overflow:'hidden', opacity:.55 }}>
          <svg width="100%" height="52" viewBox="0 0 800 52" preserveAspectRatio="none">
            <polyline
              points="0,26 60,26 80,26 90,4 100,46 112,4 124,26 160,26 220,26 240,26 250,10 258,42 268,10 276,26 340,26 400,26 420,26 430,4 440,46 452,4 464,26 520,26 580,26 600,26 610,10 618,42 628,10 636,26 700,26 800,26"
              fill="none" stroke="#1D9E75" strokeWidth="1.8"
              strokeLinecap="round" strokeLinejoin="round"
              strokeDasharray="1000"
              style={{ animation:'altimoECG 3.5s ease-in-out infinite' }}
            />
          </svg>
        </div>

        {/* Logo + anillos */}
        <div style={{ position:'relative', zIndex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%', padding:'48px' }}>
          <div style={{ position:'relative', marginBottom:'36px' }}>
            {[0, 1, 2].map(i => (
              <div key={i} style={{
                position:'absolute', top:'50%', left:'50%',
                width:'80px', height:'80px', marginTop:'-40px', marginLeft:'-40px',
                borderRadius:'50%', border:'1.5px solid rgba(29,158,117,0.55)',
                animation:'altimoPulseRing 2.8s ease-out ' + (i * .9) + 's infinite',
              }} />
            ))}
            <div style={{
              width:'80px', height:'80px', borderRadius:'50%',
              background:'linear-gradient(135deg,rgba(29,158,117,0.3),rgba(29,158,117,0.12))',
              border:'1.5px solid rgba(29,158,117,0.6)',
              display:'flex', alignItems:'center', justifyContent:'center',
              animation:'altimoHeartbeat 2.4s ease-in-out infinite, altimoGlow 2.4s ease-in-out infinite',
              position:'relative', zIndex:1,
            }}>
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
                <rect x="14" y="4"  width="10" height="30" rx="3" fill="#1D9E75"/>
                <rect x="4"  y="14" width="30" height="10" rx="3" fill="#1D9E75"/>
              </svg>
            </div>
          </div>

          <div style={{ textAlign:'center' }}>
            <img
              src={logoBlanco}
              alt="ALTIMO Medical Center"
              style={{ width:'260px', maxWidth:'85%', display:'block', margin:'0 auto', opacity: phase >= 1 ? 1 : 0, animation: phase >= 1 ? 'altimoFadeUp .7s ease .1s both' : 'none', filter:'drop-shadow(0 0 30px rgba(29,158,117,0.25))' }}
              onError={e => { e.target.style.display='none'; }}
            />
            <div style={{ height:'2px', margin:'20px auto', background:'linear-gradient(90deg,transparent,#1D9E75,transparent)', opacity: phase >= 1 ? 1 : 0, width: phase >= 1 ? '120px' : '0px', transition:'width .9s ease .4s, opacity .5s ease .4s' }} />
            <div style={{ color:'rgba(255,255,255,0.55)', fontSize:'13px', lineHeight:'1.9', maxWidth:'260px', margin:'0 auto', opacity: phase >= 1 ? 1 : 0, animation: phase >= 1 ? 'altimoFadeUp .7s ease .5s both' : 'none' }}>
              Sistema hospitalario integral de gestión clínica, facturación y expedientes
            </div>
          </div>

        </div>

        <div style={{ position:'absolute', bottom:'18px', width:'100%', textAlign:'center', fontSize:'10px', color:'rgba(255,255,255,0.18)', letterSpacing:'1.5px', zIndex:1 }}>
          v2.0 · El Salvador · Sistema de uso exclusivo interno
        </div>
      </div>

      {/* ── Panel derecho (formulario) ── */}
      <div style={{ width:'420px', flexShrink:0, background:'#f0f4f8', display:'flex', alignItems:'center', justifyContent:'center', padding:'48px 40px', opacity: phase >= 2 ? 1 : 0, transform: phase >= 2 ? 'translateX(0)' : 'translateX(48px)', transition:'opacity .65s ease .1s, transform .65s ease .1s', borderLeft:'1px solid rgba(27,42,94,0.08)' }}>
        <div style={{ width:'100%', maxWidth:'320px' }}>

          <div style={{ marginBottom:'32px', ...fd(.05) }}>
            <div style={{ fontSize:'11px', fontWeight:'700', color:'#1D9E75', letterSpacing:'.12em', textTransform:'uppercase', marginBottom:'8px' }}>Bienvenido</div>
            <div style={{ fontSize:'26px', fontWeight:'800', color:'#1B2A5E', marginBottom:'6px', lineHeight:1.2 }}>Acceso al sistema</div>
            <div style={{ fontSize:'13px', color:'#6c757d' }}>Ingresa tus credenciales institucionales</div>
          </div>

          <div style={{ height:'3px', borderRadius:'2px', marginBottom:'28px', background:'linear-gradient(90deg,#1B2A5E,#1D9E75,transparent)', ...fd(.08) }} />

          {error && (
            <div style={{ background:'#fff0f0', color:'#721c24', border:'1px solid #f5c6cb', borderLeft:'4px solid #dc3545', borderRadius:'8px', padding:'11px 14px', fontSize:'13px', marginBottom:'18px', display:'flex', alignItems:'center', gap:'8px', animation:'altimoFadeUp .3s ease both' }}>
              ⚠️ {error}
            </div>
          )}

          {/* Usuario */}
          <div style={{ marginBottom:'16px', ...fd(.12) }}>
            <label style={{ display:'block', fontSize:'11px', fontWeight:'700', color:'#1B2A5E', marginBottom:'7px', textTransform:'uppercase', letterSpacing:'.06em' }}>DUI (usuario de acceso)</label>
            <div style={{ position:'relative' }}>
              <span style={{ position:'absolute', left:'13px', top:'50%', transform:'translateY(-50%)', color:'#94a3b8', pointerEvents:'none' }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="5" r="3"/><path d="M2 14c0-3 2.7-5 6-5s6 2 6 5"/></svg>
              </span>
              <input autoFocus
                style={{ width:'100%', fontSize:'14px', padding:'12px 13px 12px 40px', border:'1.5px solid #dde3ea', borderRadius:'10px', background:'#fff', color:'#1B2A5E', outline:'none', boxSizing:'border-box', transition:'border-color .2s, box-shadow .2s', fontFamily:'Segoe UI, sans-serif' }}
                value={creds.usuario} onChange={e => setCreds(c => ({ ...c, usuario: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && handleLogin()}
                onFocus={e => { e.target.style.borderColor='#1B2A5E'; e.target.style.boxShadow='0 0 0 4px rgba(27,42,94,0.09)'; }}
                onBlur={e  => { e.target.style.borderColor='#dde3ea';  e.target.style.boxShadow='none'; }}
                placeholder="DUI (00000000-0)"
              />
            </div>
          </div>

          {/* Contraseña */}
          <div style={{ marginBottom:'28px', ...fd(.18) }}>
            <label style={{ display:'block', fontSize:'11px', fontWeight:'700', color:'#1B2A5E', marginBottom:'7px', textTransform:'uppercase', letterSpacing:'.06em' }}>Contraseña</label>
            <div style={{ position:'relative' }}>
              <span style={{ position:'absolute', left:'13px', top:'50%', transform:'translateY(-50%)', color:'#94a3b8', pointerEvents:'none' }}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="7" width="10" height="8" rx="1.5"/><path d="M5 7V5a3 3 0 0 1 6 0v2"/></svg>
              </span>
              <input type={showPass ? 'text' : 'password'}
                style={{ width:'100%', fontSize:'14px', padding:'12px 40px 12px 40px', border:'1.5px solid #dde3ea', borderRadius:'10px', background:'#fff', color:'#1B2A5E', outline:'none', boxSizing:'border-box', transition:'border-color .2s, box-shadow .2s', fontFamily:'Segoe UI, sans-serif' }}
                value={creds.password} onChange={e => setCreds(c => ({ ...c, password: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && handleLogin()}
                onFocus={e => { e.target.style.borderColor='#1B2A5E'; e.target.style.boxShadow='0 0 0 4px rgba(27,42,94,0.09)'; }}
                onBlur={e  => { e.target.style.borderColor='#dde3ea';  e.target.style.boxShadow='none'; }}
                placeholder="••••••••"
              />
              <button onClick={() => setShowPass(s => !s)}
                style={{ position:'absolute', right:'13px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'#94a3b8', padding:'2px', lineHeight:1, transition:'color .15s' }}
                onMouseEnter={e => e.currentTarget.style.color='#1B2A5E'}
                onMouseLeave={e => e.currentTarget.style.color='#94a3b8'}>
                {showPass
                  ? <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M1 8s3-5 7-5 7 5 7 5-3 5-7 5-7-5-7-5z"/><circle cx="8" cy="8" r="2"/><line x1="2" y1="2" x2="14" y2="14"/></svg>
                  : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M1 8s3-5 7-5 7 5 7 5-3 5-7 5-7-5-7-5z"/><circle cx="8" cy="8" r="2"/></svg>
                }
              </button>
            </div>
          </div>

          {/* Botón ingresar */}
          <div style={{ ...fd(.24) }}>
            <button onClick={handleLogin} disabled={cargando}
              style={{
                width:'100%', padding:'14px',
                backgroundColor: cargando ? '#94a3b8' : undefined,
                backgroundImage: cargando ? 'none' : 'linear-gradient(135deg,#0d1e45 0%,#1B2A5E 40%,#1D9E75 100%)',
                backgroundSize:'200% auto',
                color:'#fff', border:'none', borderRadius:'10px', fontSize:'14px', fontWeight:'700',
                cursor: cargando ? 'not-allowed' : 'pointer', letterSpacing:'.04em',
                boxShadow: cargando ? 'none' : '0 6px 24px rgba(27,42,94,0.35)',
                transition:'box-shadow .2s, transform .15s', fontFamily:'Segoe UI, sans-serif'
              }}
              onMouseEnter={e => { if (!cargando) { e.currentTarget.style.boxShadow='0 8px 28px rgba(27,42,94,0.48)'; e.currentTarget.style.transform='translateY(-2px)'; }}}
              onMouseLeave={e => { e.currentTarget.style.boxShadow='0 6px 24px rgba(27,42,94,0.35)'; e.currentTarget.style.transform='translateY(0)'; }}
              onMouseDown={e => { e.currentTarget.style.transform='translateY(1px)'; }}
              onMouseUp={e =>   { e.currentTarget.style.transform='translateY(-2px)'; }}>
              {cargando ? (
                <span style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'10px' }}>
                  <span style={{ width:'15px', height:'15px', border:'2px solid rgba(255,255,255,0.35)', borderTopColor:'#fff', borderRadius:'50%', display:'inline-block', animation:'altimoSpin .7s linear infinite' }} />
                  Verificando acceso...
                </span>
              ) : 'Ingresar al sistema →'}
            </button>
          </div>

          {/* Footer login */}
          <div style={{ marginTop:'28px', ...fd(.3) }}>
            <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'14px' }}>
              <div style={{ flex:1, height:'1px', background:'#dde3ea' }} />
              <span style={{ fontSize:'10px', color:'#c0ccda', whiteSpace:'nowrap', letterSpacing:'.05em' }}>ACCESO INSTITUCIONAL</span>
              <div style={{ flex:1, height:'1px', background:'#dde3ea' }} />
            </div>
            <div style={{ display:'flex', justifyContent:'center', gap:'6px', alignItems:'center' }}>
              <div style={{ width:'8px', height:'8px', borderRadius:'50%', background:'#1D9E75', animation:'altimoHeartbeat 2.4s ease-in-out infinite' }} />
              <span style={{ fontSize:'11px', color:'#adb5bd' }}>Sistema seguro · ALTIMO Medical Center</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════
//  MODAL: Cambio obligatorio de contraseña (primer ingreso / reseteo)
// ════════════════════════════════════════════════════════════
function ModalCambiarPassword({ usuario, onCambiada }) {
  const [form,      setForm]      = useState({ nueva: '', confirmar: '' });
  const [cargando,  setCargando]  = useState(false);
  const [error,     setError]     = useState('');
  const [showNueva, setShowNueva] = useState(false);
  const [showConf,  setShowConf]  = useState(false);

  const PASSWORD_PROHIBIDA = 'bienvenidoaltimo';

  const fortaleza = (p) => {
    if (p.length < 8) return 0;
    let pts = 0;
    if (p.match(/[A-Z]/)) pts++;
    if (p.match(/[a-z]/)) pts++;
    if (p.match(/[0-9]/)) pts++;
    if (p.match(/[^A-Za-z0-9]/)) pts++;
    return pts;
  };

  const nivelColor = ['#dc3545','#ffc107','#17a2b8','#28a745'];
  const nivelLabel = ['Muy débil','Débil','Aceptable','Fuerte'];
  const nivel = fortaleza(form.nueva);

  const guardar = async () => {
    setError('');
    if (!form.nueva) { setError('Ingresa tu nueva contraseña.'); return; }
    if (form.nueva.toLowerCase() === PASSWORD_PROHIBIDA)
      { setError('No puedes usar la contraseña inicial. Elige una contraseña personal.'); return; }
    if (form.nueva.length < 8) { setError('La contraseña debe tener al menos 8 caracteres.'); return; }
    if (nivel < 2) { setError('La contraseña es muy débil. Usa mayúsculas, números o símbolos.'); return; }
    if (form.nueva !== form.confirmar) { setError('Las contraseñas no coinciden.'); return; }
    setCargando(true);
    const r = await api.usuarios.cambiarPassword({ id: usuario.id, nuevaPassword: form.nueva }); // ← antes: window.altimo.usuarios.cambiarPassword(...)
    setCargando(false);
    if (r.ok) {
      onCambiada();
    } else {
      setError(r.error || 'Error al guardar la contraseña.');
    }
  };

  const inputStyle = { width:'100%', fontSize:'14px', padding:'11px 42px 11px 14px', border:'1.5px solid #dde3ea', borderRadius:'10px', background:'#fff', color:'#1B2A5E', outline:'none', boxSizing:'border-box', fontFamily:'Segoe UI, sans-serif' };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(10,20,55,0.78)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999, fontFamily:'Segoe UI, sans-serif' }}>
      <div style={{ background:'#fff', borderRadius:'16px', padding:'36px 36px 28px', width:'420px', boxShadow:'0 32px 80px rgba(0,0,0,0.4)', border:'1px solid #dde3ea' }}>

        {/* Encabezado */}
        <div style={{ textAlign:'center', marginBottom:'24px' }}>
          <div style={{ fontSize:'40px', marginBottom:'10px' }}>🔐</div>
          <div style={{ fontSize:'20px', fontWeight:'800', color:'#1B2A5E', marginBottom:'6px' }}>
            Cambio de contraseña requerido
          </div>
          <div style={{ fontSize:'13px', color:'#6c757d', lineHeight:1.5 }}>
            Bienvenido/a, <strong>{usuario.nombre}</strong>.<br />
            Por seguridad debes establecer tu contraseña personal antes de continuar.
          </div>
        </div>

        <div style={{ height:'2px', background:'linear-gradient(90deg,#1B2A5E,#1D9E75)', borderRadius:'2px', marginBottom:'22px' }} />

        {error && (
          <div style={{ background:'#fff0f0', color:'#721c24', border:'1px solid #f5c6cb', borderLeft:'4px solid #dc3545', borderRadius:'8px', padding:'10px 13px', fontSize:'13px', marginBottom:'16px' }}>
            ⚠️ {error}
          </div>
        )}

        {/* Nueva contraseña */}
        <div style={{ marginBottom:'14px' }}>
          <label style={{ display:'block', fontSize:'11px', fontWeight:'700', color:'#1B2A5E', marginBottom:'7px', textTransform:'uppercase', letterSpacing:'.06em' }}>Nueva contraseña</label>
          <div style={{ position:'relative' }}>
            <input type={showNueva ? 'text' : 'password'} style={inputStyle}
              value={form.nueva} onChange={e => setForm(f => ({ ...f, nueva: e.target.value }))}
              onKeyDown={e => e.key === 'Enter' && guardar()}
              placeholder="Mínimo 8 caracteres" autoFocus />
            <button onClick={() => setShowNueva(s => !s)}
              style={{ position:'absolute', right:'13px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'#94a3b8', fontSize:'16px' }}>
              {showNueva ? '🙈' : '👁️'}
            </button>
          </div>
          {form.nueva.length > 0 && (
            <div style={{ marginTop:'8px' }}>
              <div style={{ display:'flex', gap:'4px', marginBottom:'4px' }}>
                {[0,1,2,3].map(i => (
                  <div key={i} style={{ flex:1, height:'4px', borderRadius:'2px', background: i < nivel ? nivelColor[nivel - 1] : '#e8f0fb', transition:'background .3s' }} />
                ))}
              </div>
              <div style={{ fontSize:'11px', color: nivelColor[nivel - 1] || '#adb5bd' }}>
                {form.nueva.length < 8 ? 'Mínimo 8 caracteres' : nivelLabel[nivel - 1] || 'Muy débil'}
              </div>
            </div>
          )}
        </div>

        {/* Confirmar */}
        <div style={{ marginBottom:'22px' }}>
          <label style={{ display:'block', fontSize:'11px', fontWeight:'700', color:'#1B2A5E', marginBottom:'7px', textTransform:'uppercase', letterSpacing:'.06em' }}>Confirmar contraseña</label>
          <div style={{ position:'relative' }}>
            <input type={showConf ? 'text' : 'password'} style={inputStyle}
              value={form.confirmar} onChange={e => setForm(f => ({ ...f, confirmar: e.target.value }))}
              onKeyDown={e => e.key === 'Enter' && guardar()}
              placeholder="Repite la nueva contraseña" />
            <button onClick={() => setShowConf(s => !s)}
              style={{ position:'absolute', right:'13px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'#94a3b8', fontSize:'16px' }}>
              {showConf ? '🙈' : '👁️'}
            </button>
          </div>
          {form.confirmar.length > 0 && form.nueva !== form.confirmar && (
            <div style={{ fontSize:'11px', color:'#dc3545', marginTop:'4px' }}>Las contraseñas no coinciden.</div>
          )}
        </div>

        <button onClick={guardar} disabled={cargando}
          style={{ width:'100%', padding:'13px', background: cargando ? '#94a3b8' : 'linear-gradient(135deg,#1B2A5E,#1D9E75)', color:'#fff', border:'none', borderRadius:'10px', fontSize:'14px', fontWeight:'700', cursor: cargando ? 'not-allowed' : 'pointer', letterSpacing:'.04em' }}>
          {cargando ? '⏳ Guardando...' : '✓ Establecer contraseña y continuar →'}
        </button>

        <div style={{ marginTop:'14px', padding:'10px 12px', background:'#f8fafd', borderRadius:'8px', fontSize:'11px', color:'#6c757d', display:'flex', gap:'8px', alignItems:'flex-start' }}>
          <span>🔒</span>
          <span>Tu contraseña es personal y confidencial. No la compartas con nadie. Usa al menos 8 caracteres con mayúsculas y números.</span>
        </div>
      </div>
    </div>
  );
}

function areaDeRol(rol) {
  if (!rol) return 'Todas';
  const r = String(rol).toLowerCase();
  if (r === 'admin') return 'Todas';
  if (r.includes('lab')) return 'Laboratorio';
  if (r.includes('factur') || r.includes('caja') || r.includes('contadur') || r.includes('audit')) return 'Facturacion';
  if (r.includes('farm')) return 'Farmacia';
  if (r.includes('jefa_enfer') || r.includes('enfer')) return 'Enfermeria';
  if (r.includes('medic')) return 'Medicos';
  if (r.includes('admis') || r.includes('recep')) return 'Administracion';
  return 'Todas';
}

function fmtNotifFecha(fecha) {
  if (!fecha) return '';
  try { return new Date(String(fecha).replace(' ', 'T')).toLocaleString('es-SV'); }
  catch (_) { return fecha; }
}

// ════════════════════════════════════════════════════════════
//  APP PRINCIPAL
// ════════════════════════════════════════════════════════════
export default function App() {
  const [usuario,        setUsuario]        = useState(null);
  const [modulo,         setModulo]         = useState('dashboard');
  const [admisionActiva, setAdmisionActiva] = useState(null);
  const [formularioNav,  setFormularioNav]  = useState(null);
  const [moduloParams,   setModuloParams]   = useState(null);
  const [seccionesOpen,  setSeccionesOpen]  = useState({ PRINCIPAL:true, 'CLÍNICO':true, SERVICIOS:true, 'FACTURACIÓN':true, SISTEMA:true });
  const [notificaciones, setNotificaciones] = useState([]);
  const [notifOpen,      setNotifOpen]      = useState(false);
  const [notifCargando,  setNotifCargando]  = useState(false);
  const [buscadorOpen,   setBuscadorOpen]   = useState(false);

  const areaUsuario = useMemo(() => areaDeRol(usuario?.rol), [usuario?.rol]);

  const modulosVisibles = useMemo(() => {
    if (!usuario) return [];
    return MODULOS.filter(m => PERMISOS[m.id]?.includes(usuario.rol));
  }, [usuario]);

  const moduloActivo = useMemo(() => {
    if (!usuario) return 'dashboard';
    return modulosVisibles.some(m => m.id === modulo)
      ? modulo
      : (modulosVisibles[0]?.id || 'dashboard');
  }, [usuario, modulosVisibles, modulo]);

  const tituloActual = useMemo(() => (
    MODULOS.find(m => m.id === moduloActivo)?.label || ''
  ), [moduloActivo]);

  const modulosAgrupados = useMemo(() => {
    const grupos = [];
    let actual = null;
    modulosVisibles.forEach(m => {
      const nombreSeccion = m.seccion || actual?.seccion || 'OTROS';
      if (!actual || m.seccion) {
        actual = { seccion: nombreSeccion, items: [] };
        grupos.push(actual);
      }
      actual.items.push(m);
    });
    return grupos;
  }, [modulosVisibles]);

  const cargarNotificaciones = async (silencioso = true) => {
    if (!usuario || !window.altimo?.notificaciones) return;
    try {
      if (!silencioso) setNotifCargando(true);
      const r = await window.altimo.notificaciones.listar({
        area: areaUsuario,
        rol: usuario.rol,
        solo_no_leidas: false,
        limite: 30,
      });
      if (r.ok) setNotificaciones(r.data || []);
    } finally {
      if (!silencioso) setNotifCargando(false);
    }
  };

  useEffect(() => {
    if (!usuario) return;
    cargarNotificaciones(false);
    const t = setInterval(() => cargarNotificaciones(true), 15000);
    return () => clearInterval(t);
  }, [usuario?.id, usuario?.rol, areaUsuario]);

  useEffect(() => {
    if (!usuario) return;
    const handler = () => cargarNotificaciones(true);
    window.addEventListener('focus', handler);
    return () => window.removeEventListener('focus', handler);
  }, [usuario?.id, usuario?.rol, areaUsuario]);

  // ── Atajo de teclado para Búsqueda Global (Cmd/Ctrl+K) ──────
  useEffect(() => {
    if (!usuario) return;
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setBuscadorOpen(true);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [usuario]);

  const noLeidas = notificaciones.filter(n => !n.leida).length;

  const marcarNotifLeida = async (id) => {
    if (!window.altimo?.notificaciones) return;
    await window.altimo.notificaciones.marcarLeida({ id });
    setNotificaciones(prev => prev.map(n => n.id === id ? { ...n, leida: 1, leida_en: new Date().toISOString() } : n));
  };

  const marcarTodasNotif = async () => {
    if (!usuario || !window.altimo?.notificaciones) return;
    await window.altimo.notificaciones.marcarTodasLeidas({ area: areaUsuario, rol: usuario.rol });
    setNotificaciones(prev => prev.map(n => ({ ...n, leida: 1, leida_en: new Date().toISOString() })));
  };

  const irACuenta = (id) => {
    if (!usuario || !PERMISOS.cuenta?.includes(usuario.rol)) return;
    setAdmisionActiva(id);
    setModulo('cuenta');
  };

  const irAFacturacion = (id) => {
    if (!usuario || !PERMISOS.facturacion?.includes(usuario.rol)) return;
    setAdmisionActiva(id);
    setModulo('facturacion');
  };

  const irAFormulario = (admisionId, formularioId) => {
    if (!usuario || !PERMISOS.formularios?.includes(usuario.rol)) return;
    setFormularioNav({ admisionId, formularioId });
    setModulo('clinica');
  };

  const cambiarModulo = (id) => {
    if (!usuario || !PERMISOS[id]?.includes(usuario.rol)) return;
    if (id !== 'formularios') setFormularioNav(null);
    setModulo(id);
  };

  // Usado por BuscadorGlobal para navegar a un módulo sin admisión asociada
  // (ej. resultado tipo "paciente" sin admisión activa → Expedientes).
  // params (opcional): datos extra para el módulo destino (ej. filtro inicial).
  const irAModulo = (id, params = null) => { setModuloParams(params); cambiarModulo(id); };

  // Navegación dirigida desde "Mi panel" (Dashboard) → abrir directo el
  // expediente de un paciente puntual y hacer scroll a su sección de
  // Estudios Clínicos (OrdenesLabPanel), sin pasar por Cuenta/Facturación
  // ni obligar al médico a buscarlo manualmente en la tabla de expedientes.
  const irAExpedienteLab = (pacienteId, admisionId) => {
    if (!usuario || !PERMISOS.expediente?.includes(usuario.rol)) return;
    setModuloParams({ pacienteId, admisionId, irA: 'labs' });
    cambiarModulo('expediente');
  };

  const toggleSeccion = (seccion) => setSeccionesOpen(prev => ({ ...prev, [seccion]: !(prev[seccion] ?? true) }));

  const cerrarSesion = () => {
    setUsuario(null);
    setAdmisionActiva(null);
    setFormularioNav(null);
    setModulo('dashboard');
    setNotificaciones([]);
    setNotifOpen(false);
  };

  const renderContenido = () => {
    if (!usuario) return null;
    if (!PERMISOS[moduloActivo]?.includes(usuario.rol)) {
      return (
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%', color:'#6c757d' }}>
          <div style={{ fontSize:'48px', marginBottom:'16px' }}>🔒</div>
          <div style={{ fontSize:'16px', fontWeight:'700', color:'#1B2A5E' }}>Acceso restringido</div>
          <div style={{ fontSize:'13px', marginTop:'6px' }}>No tienes permisos para acceder a este módulo.</div>
        </div>
      );
    }

    switch (moduloActivo) {
      case 'dashboard':    return <Dashboard          usuario={usuario} onVerCuenta={irACuenta} onIrAModulo={irAModulo} onIrAExpedienteLab={irAExpedienteLab} />;
      case 'admision':     return <AdmisionModulo      usuario={usuario} onAdmisionCreada={(id) => { cargarNotificaciones(true); irACuenta(id); }} />;
      case 'expediente':   return <ExpedientePaciente  usuario={usuario} onVerCuenta={irACuenta} onAbrirFormulario={irAFormulario} navInicial={moduloParams} />;
      case 'clinica':      return <ClinicaMedica        usuario={usuario} onVerCuenta={irACuenta} onAbrirFormulario={irAFormulario} />;
      case 'enfermeria':   return <Enfermeria           usuario={usuario} filtroInicial={moduloParams?.filtro} />;
      case 'habitaciones': return <Habitaciones         usuario={usuario} />;
      case 'turnos':       return <Turnos               usuario={usuario} />;
      case 'quirofano':    return <ProgramacionQuirofano usuario={usuario} />;
      case 'laboratorio':  return <Laboratorio          usuario={usuario} filtroInicial={moduloParams?.filtro} />;
      case 'inventario':   return <Inventario           usuario={usuario} />;
      case 'farmacia':     return <Farmacia             usuario={usuario} filtroInicial={moduloParams?.filtro} />;
      case 'medicos':      return <Medicos              usuario={usuario} />;
      case 'usuarios':     return <Usuarios             usuario={usuario} />;
      case 'cuenta':       return <CuentaPaciente       usuario={usuario} admisionId={admisionActiva} onIrFacturacion={irAFacturacion} />;
      case 'facturacion':  return <FacturacionModulo    usuario={usuario} admisionId={admisionActiva} onIrFacturacion={irAFacturacion} />;
      case 'reportes':     return <Reportes             usuario={usuario} />;
      case 'tarifario':    return <Tarifario            usuario={usuario} />;
      case 'activosFijos': return <ActivosFijos         usuario={usuario} />;
      default:             return null;
    }
  };

  if (!usuario) return <Login onLogin={setUsuario} />;

  // Cambio obligatorio de contraseña (primer ingreso o tras reseteo)
  if (usuario.debe_cambiar_password) {
    return (
      <ModalCambiarPassword
        usuario={usuario}
        onCambiada={() => setUsuario(u => ({ ...u, debe_cambiar_password: 0 }))}
      />
    );
  }

  return (
    <div style={G.app}>
      <div style={G.sidebar}>
        <div style={G.logoArea}>
          <img src={logo} alt="ALTIMO" style={G.logoImg} onError={e => { e.target.style.display='none'; }} />
        </div>

        <div style={{ flex:1, overflowY:'auto', paddingBottom:'8px' }}>
          {modulosAgrupados.map(grupo => {
            const abierta = seccionesOpen[grupo.seccion] ?? true;
            return (
              <div key={grupo.seccion}>
                <div
                  style={G.navSectionBtn(abierta)}
                  onClick={() => toggleSeccion(grupo.seccion)}
                  title={abierta ? 'Contraer sección' : 'Expandir sección'}>
                  <span>{grupo.seccion}</span>
                  <span style={G.navSectionArrow(abierta)}>▶</span>
                </div>
                {abierta && grupo.items.map(m => (
                  <div
                    key={m.id}
                    style={G.navItem(moduloActivo === m.id)}
                    onClick={() => cambiarModulo(m.id)}
                    onMouseEnter={e => {
                      if (moduloActivo !== m.id) {
                        e.currentTarget.style.background = '#ffffff';
                        e.currentTarget.style.color = '#1B2A5E';
                      }
                    }}
                    onMouseLeave={e => {
                      if (moduloActivo !== m.id) {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = '#dbe7f5';
                      }
                    }}>
                    {m.ico} {m.label}
                  </div>
                ))}
              </div>
            );
          })}
        </div>

        <div style={{ padding:'12px 0', borderTop:'1px solid rgba(255,255,255,.1)' }}>
          <div style={{ padding:'6px 16px', marginBottom:'4px' }}>
            <div style={{ fontSize:'12px', fontWeight:'600', color:'rgba(255,255,255,.85)', marginBottom:'2px' }}>
              {usuario.nombre}
            </div>
            <div style={{ fontSize:'10px', color:'rgba(255,255,255,.45)' }}>
              {ROL_LABEL[usuario.rol] || usuario.rol}
            </div>
          </div>
          <div style={{ ...G.navItem(false), borderBottom:'none', color:'#ff9a9a' }} onClick={cerrarSesion}>
            {Ico.logout} Cerrar sesión
          </div>
        </div>
      </div>

      <div style={G.main}>
        <div style={G.topbar}>
          <span style={G.topbarTitulo}>{tituloActual}</span>

          <button
            onClick={() => setBuscadorOpen(true)}
            title="Búsqueda global (Ctrl/Cmd+K)"
            style={{
              border:'1px solid #dde3ea', background:'#fff', color:'#1B2A5E',
              borderRadius:'9px', height:'34px', padding:'0 12px', cursor:'pointer',
              fontSize:'13px', display:'flex', alignItems:'center', gap:'7px'
            }}>
            🔍 <span style={{ color:'#6c757d' }}>Buscar...</span>
            <span style={{ fontSize:'10px', color:'#adb5bd', border:'1px solid #dde3ea', borderRadius:'5px', padding:'1px 5px', marginLeft:'4px' }}>
              Ctrl+K
            </span>
          </button>

          <div style={{ position:'relative' }}>
            <button
              onClick={() => { const abrir = !notifOpen; setNotifOpen(abrir); if (abrir) cargarNotificaciones(false); }}
              title="Notificaciones"
              style={{
                position:'relative', border:'1px solid #dde3ea', background:'#fff', color:'#1B2A5E',
                borderRadius:'9px', width:'38px', height:'34px', cursor:'pointer', fontSize:'17px',
                display:'flex', alignItems:'center', justifyContent:'center'
              }}>
              🔔
              {noLeidas > 0 && (
                <span style={{
                  position:'absolute', top:'-6px', right:'-6px', minWidth:'18px', height:'18px',
                  borderRadius:'99px', background:'#dc3545', color:'#fff', fontSize:'10px',
                  fontWeight:'800', display:'flex', alignItems:'center', justifyContent:'center',
                  padding:'0 5px', border:'2px solid #fff'
                }}>{noLeidas > 99 ? '99+' : noLeidas}</span>
              )}
            </button>

            {notifOpen && (
              <div style={{
                position:'absolute', top:'42px', right:0, width:'360px', maxHeight:'480px', overflowY:'auto',
                background:'#fff', border:'1px solid #dde3ea', borderRadius:'12px', boxShadow:'0 18px 45px rgba(0,0,0,.18)',
                zIndex:2000, padding:'12px'
              }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px', borderBottom:'2px solid #e8f0fb', paddingBottom:'8px' }}>
                  <div>
                    <div style={{ fontSize:'12px', fontWeight:'800', color:'#1B2A5E', textTransform:'uppercase', letterSpacing:'.04em' }}>Notificaciones</div>
                    <div style={{ fontSize:'10px', color:'#6c757d' }}>{ROL_LABEL[usuario.rol] || usuario.rol}</div>
                  </div>
                  <button onClick={marcarTodasNotif} style={{ border:'1px solid #c0ccda', background:'#fff', borderRadius:'7px', padding:'5px 8px', fontSize:'11px', cursor:'pointer' }}>
                    Marcar todas
                  </button>
                </div>

                {notifCargando ? (
                  <div style={{ padding:'18px', textAlign:'center', color:'#6c757d', fontSize:'12px' }}>Actualizando...</div>
                ) : notificaciones.length === 0 ? (
                  <div style={{ padding:'18px', textAlign:'center', color:'#6c757d', fontSize:'12px' }}>Sin notificaciones</div>
                ) : (
                  notificaciones.map(n => (
                    <div
                      key={n.id}
                      onClick={() => !n.leida && marcarNotifLeida(n.id)}
                      style={{
                        display:'flex', gap:'9px', padding:'9px 8px', borderRadius:'8px', cursor:n.leida?'default':'pointer',
                        background:n.leida ? '#f8fafd' : '#fff', border:`1px solid ${n.leida ? '#eef1f6' : '#ffc107'}`,
                        marginBottom:'7px', opacity:n.leida ? .68 : 1
                      }}>
                      <div style={{ width:'8px', height:'8px', borderRadius:'50%', marginTop:'5px', background:n.leida ? '#adb5bd' : '#1D9E75', flexShrink:0 }} />
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:'flex', alignItems:'center', gap:'6px', flexWrap:'wrap' }}>
                          <div style={{ fontSize:'12px', fontWeight:n.leida ? '500' : '800', color:'#1B2A5E' }}>{n.titulo}</div>
                          {n.prioridad && (
                            <span style={{
                              fontSize:'9px', fontWeight:'800', textTransform:'uppercase', borderRadius:'99px', padding:'2px 6px',
                              background: n.prioridad === 'alta' ? '#f8d7da' : n.prioridad === 'media' ? '#fff3cd' : '#e2e3e5',
                              color: n.prioridad === 'alta' ? '#721c24' : n.prioridad === 'media' ? '#856404' : '#383d41',
                            }}>{n.prioridad}</span>
                          )}
                        </div>
                        <div style={{ fontSize:'11px', color:'#495057', marginTop:'3px', lineHeight:1.35 }}>{n.cuerpo || n.mensaje || ''}</div>
                        <div style={{ display:'flex', justifyContent:'space-between', marginTop:'5px', gap:'8px' }}>
                          <span style={{ fontSize:'10px', color:'#6c757d' }}>{n.area || 'Todas'}</span>
                          <span style={{ fontSize:'10px', color:'#adb5bd' }}>{fmtNotifFecha(n.fecha)}</span>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>

          <span style={G.badge(ROL_COLOR[usuario.rol])}>
            {ROL_LABEL[usuario.rol] || usuario.rol}
          </span>
        </div>
        <div style={G.contenido}>{renderContenido()}</div>
      </div>

      <BuscadorGlobal
        usuario={usuario}
        PERMISOS={PERMISOS}
        abierto={buscadorOpen}
        onCerrar={() => setBuscadorOpen(false)}
        onIrACuenta={irACuenta}
        onIrAFacturacion={irAFacturacion}
        onIrAModulo={irAModulo}
      />
    </div>
  );
}
